document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
function onDOMContentLoaded() {
  initCaseSlider();
}
/* -------------------------------------------------------------------------------------
 initCaseSlider
------------------------------------------------------------------------------------- */
const caseSliderWrapIds = ["caseSlider-wrap1"];
const swipers = [];
function initCaseSlider() {
  for (const id of caseSliderWrapIds) {
    const swiper = new Swiper("#"+id+" .caseSlider", {
      slidesPerView: "auto",
      spaceBetween: 40,
      pagination: {
        el: "#"+id+" .swiper-pagination",
        clickable: true
      },
      navigation: {
        nextEl: "#"+id+" .swiper-button-next",
        prevEl: "#"+id+" .swiper-button-prev",
      },
      breakpoints: {
        0: {
          spaceBetween: 0,
        },
        768: {
          spaceBetween: 40,
        }
      },
    });
    swipers.push(swiper);
  }
}
